<template>
  <div>
    <!-- Tab Navigation -->
    <div
      style="
        margin-left: 2em;
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        padding: 12px 16px;
        border-bottom: 1px solid #e5e7eb;
        background: linear-gradient(to right, #f9fafb, #f3f4f6);
      "
    >
      <a
        :href="'/mch/maternity_treatment/anc-profile/' + $route.params.visit_id"
        :class="[
          'tab-link',
          $route.fullPath ==
          '/mch/maternity_treatment/anc-profile/' + $route.params.visit_id
            ? 'active-tab'
            : '',
        ]"
      >
        🧍‍♀️📋 Antenatal Profile
      </a>

      <a
        :href="'/mch/maternity_treatment/labor-progress/' + $route.params.visit_id"
        :class="[
          'tab-link',
          $route.fullPath == '/mch/maternity_treatment/labor-progress/' + $route.params.visit_id
            ? 'active-tab'
            : '',
        ]"
      >
        🔄 Labor progress
      </a>

      <a
        :href="'/mch/maternity_treatment/investigations/' + $route.params.visit_id"
        :class="[
          'tab-link',
          $route.fullPath == '/mch/maternity_treatment/investigations/' + $route.params.visit_id
            ? 'active-tab'
            : '',
        ]"
      >
        🔬 Investigations & Lab Results
      </a>

      <a
        :href="'/mch/maternity_treatment/delivery/' + $route.params.visit_id"
        :class="[
          'tab-link',
          $route.fullPath == '/mch/maternity_treatment/delivery/' + $route.params.visit_id
            ? 'active-tab'
            : '',
        ]"
      >
        ➡️👶 Delivery
      </a>

      <a
        :href="'/mch/maternity_treatment/newborn/' + $route.params.visit_id"
        :class="[
          'tab-link',
          $route.fullPath == '/mch/maternity_treatment/newborn/' + $route.params.visit_id
            ? 'active-tab'
            : '',
        ]"
      >
        👶 Newborn Information
      </a>

      <a
        :href="'/mch/maternity_treatment/postpartum/' + $route.params.visit_id"
        :class="[
          'tab-link',
          $route.fullPath == '/mch/maternity_treatment/postpartum/' + $route.params.visit_id
            ? 'active-tab'
            : '',
        ]"
      >
        🤱 Immediate Postpartum
      </a>

      <a
        :href="'/mch/maternity_treatment/bed-assignment/' + $route.params.visit_id"
        :class="[
          'tab-link',
          $route.fullPath == '/mch/maternity_treatment/bed-assignment/' + $route.params.visit_id
            ? 'active-tab'
            : '',
        ]"
      >
        🛏️ Bed/Ward Assignment
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "maternity_head",
  methods: {
    activeTabChange() {
      this.loading = true;
    },
  },
  mounted() {
    console.log(this.$route.fullPath);
  },
};
</script>

<style scoped>
.tab-link {
  padding: 8px 14px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #495057;
  text-decoration: none;
  background: white;
  border: 1px solid #e5e7eb;
  white-space: nowrap;
  transition: all 0.2s ease;
}

.tab-link:hover {
  background: #eef2ff;
  color: #4338ca;
}

.active-tab {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-color: transparent;
}
</style>
